import { defineComponent as _defineComponent } from 'vue'
import Loading from '../../../common/Loading/index.vue';
import { isPC } from '../../../../utils/env';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return { __sfc: true,Loading, isPC }
}

})